@if ( cards.length> 0 && !isLoading) {
<!-- Desktop carousel (3 cards por slide, avanzando de a 1) -->
<ngb-carousel
  [showNavigationArrows]="cards.length > 3"
  [showNavigationIndicators]="cards.length > 3"
  [interval]="cards.length > 3 ? 5000 : 0"
  class="google-reviews-comments-ngb desktop-carousel"
>
  @for (slide of slidingWindows; track $index) {
  <ng-template ngbSlide>
    <div class="card-carousel-group">
      @for (card of slide; track card.reviewId) {
      <ng-container
        *ngTemplateOutlet="carouselCard; context: { $implicit: card }"
      ></ng-container>
      }
    </div>
  </ng-template>
  }
</ngb-carousel>

<!-- Mobile carousel (1 card per slide) -->

<ngb-carousel
  [showNavigationArrows]="true"
  [showNavigationIndicators]="false"
  [interval]="5000"
  class="google-reviews-comments-ngb mobile-carousel"
>
  @for (card of cards; track card.reviewId) {
  <ng-template ngbSlide>
    <div class="card-carousel-group mobile-group">
      <ng-container
        *ngTemplateOutlet="carouselCard; context: { $implicit: card }"
      ></ng-container>
    </div>
  </ng-template>
  }
</ngb-carousel>

<ng-template #carouselCard let-card>
  <div class="card-carousel">
    <div class="card-carousel__content">
      <div class="card-carousel__header">
        @if(card.profilePhotoUrl){
        <div class="card-carousel__google-logo">
          <img [src]="card.profilePhotoUrl" alt="" />
        </div>
        }
        <div class="card-carousel__author">
          <div class="card-carousel__author-name">
            {{ card.profileName }}
          </div>
          <!-- <div class="card-carousel__author-role">
              {{ getAuthorRole(card) }}
            </div> -->
        </div>
      </div>
      <!-- Stars rating -->
      <div class="card-carousel__stars">
        <app-star-rating
          [rating]="card.rating"
          [hasSvg]="true"
        ></app-star-rating>
      </div>
      <!-- Review text -->
      <div
        class="card-carousel__text"
        customTooltip
        [onlyForOverflow]="
          shouldShowTooltip(
            translateService.getCurrentLang() === 'es'
              ? card.description
              : card.description_en
          )
        "
        [customTooltipLabel]="
          translateService.getCurrentLang() === 'es'
            ? card.description
            : card.description_en
        "
        [customTooltipPosition]="'above'"
        tooltipPositionText="left"
        customTooltipWaxWidth="350"
      >
        {{
          truncateText(
            this.currentLang === "es" ? card.description : card.description_en
          )
        }}
      </div>
      <!-- Author info and Google logo -->
      <div class="card-carousel__footer">
        <div class="card-carousel__author">
          <div class="card-carousel__author-name">
            <!-- {{ card.profileName }} -->
          </div>
          <!-- <div class="card-carousel__author-role">
              {{ getAuthorRole(card) }}
            </div> -->
        </div>
        @if(card && card.profilePhotoUrl){
        <div class="card-carousel__google-logo">
          <!-- <img [src]="card.profilePhotoUrl" alt="" /> -->
          <img src="./../../../../assets/icons/logo-google.svg" alt="" />
        </div>
        }
      </div>
    </div>
  </div>
</ng-template>
}
